import { useState, useRef, useEffect } from 'react';
import { useLang } from '@/i18n';
import EditorImg from 'lowcode/components/EditorImg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import styles from './index.module.scss';

const CERTIFICATION_LIST = [
    {
        key: 'section1',
        title: 'section1_title',
        desc: 'section1_desc',
    },
    {
        key: 'section2',
        title: 'section2_title',
        desc: 'section2_desc',
    },
    {
        key: 'section3',
        title: 'section3_title',
        desc: 'section3_desc',
    },
];

export default function Comp() {
    const { t } = useLang('dp3.page_v2.GraphicItems');
    const swiperRef = useRef<any>(null);
    const [gap, setGap] = useState(18);

    // 轮播图数据
    const LIST_DATA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745899447333/1.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745899447909/2.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745899448444/3.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745899447611/4.jpg',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];

    // 轮播控制函数
    const handleScroll = (direction: 'left' | 'right') => {
        if (!swiperRef.current) return;
        direction === 'left' ? swiperRef.current.slidePrev() : swiperRef.current.slideNext();
    };

    // 响应式间距设置
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 18 : window.innerWidth < 768 ? 10 : 14);
        }
    }, []);

    return (
        <div className={styles.comp} id="GraphicItems">
            <EcoSpace />
            <EcoTitle className="title" title={t('title')} />
            <div className="comp-desc">{t('desc')}</div>
            <div className="comp-flex-container">
                <div className="comp-flex-wrapper">
                    {CERTIFICATION_LIST.map((item) => (
                        <div className="comp-flex-item">
                            <h3>{t(item.title)}</h3>
                            <p>{t(item.desc)}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Swiper 组件部分 */}
            <div className="comp-module">
                <Swiper
                    className="swiper-box"
                    spaceBetween={gap}
                    slidesPerView="auto"
                    navigation={{
                        nextEl: '.graphic-swiper-button-next',
                        prevEl: '.graphic-swiper-button-prev',
                    }}
                    modules={[Navigation]}
                    initialSlide={0}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                >
                    {LIST_DATA.map((item, index) => (
                        <SwiperSlide className={`card comp-item comp-item-${index + 1}`} key={index}>
                            <div className="comp-item-img">
                                <EditorImg pc={item.pc} />
                            </div>
                            <div className="comp-item-msg">
                                <div className="comp-item-title">{item.title}</div>
                                <div className="comp-item-desc">{item.desc}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* 导航按钮 */}
            <div className="eco-swiper-control eco-swiper-control-white scrollIcons">
                <div className="eco-swiper-navigation">
                    <div className="eco-swiper-button-prev graphic-swiper-button-prev" onClick={() => handleScroll('left')}>
                        <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                    </div>
                    <div className="eco-swiper-button-next graphic-swiper-button-next" onClick={() => handleScroll('right')}>
                        <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                    </div>
                </div>
            </div>
        </div>
    );
}
